import { inject, Injectable } from '@angular/core';
import { Permissions } from '../enums/permissions.enum';
import { UserStateService } from './user-state.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private userState = inject(UserStateService);

  setPermissions(permissions: Permissions[]): void {
    this.userState.setPermissions(permissions);
  }

  clearPermissions(): void {
    this.userState.setPermissions([]);
  }

  has(permission: Permissions): boolean {
    return this.userState.permissions().includes(permission);
  }

  hasAny(perms: Permissions[]): boolean {
    const currentPerms = this.userState.permissions();
    return perms.some((p) => currentPerms.includes(p));
  }

  isDoctor(): boolean {
    return this.userState.isDoctor();
  }

  isManager(): boolean {
    return this.userState.isManager();
  }

  isReception(): boolean {
    return this.userState.isReception();
  }

  getAvailableRoles(): string[] {
    return this.userState.availableRoles();
  }

  getActiveRole(): string | null {
    return this.userState.userRole();
  }
}
